import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

/**
 * Returns the count of non-deleted macros for the current client.
 * Lighter than getMacros, which fetches full content + history.
 */
export const getMacroCount = api(async function getMacroCount() {
    return query(
        gql`
            query GetMacroCount {
                getMacroCount
            }
        `,
        {},
        { returns: "getMacroCount" }
    )
})
